import { useEffect } from 'react';
import cn from 'classnames';
import './index.scss';

export const VARIANT = Object.freeze({
    PLAIN: 'plain',
    LINK: 'link',
    ACTION: 'action',
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    TERTIARY: 'tertiary',
    DESTRUCTIVE: 'destructive',
});

export const SIZE = Object.freeze({
    S: 's',
    M: 'm',
});

const Btn = ({ icon, type = 'button', variant, size, className = '', label, children, ...rest }) => {
    const CLASS = 'botton';
    const isValidVariant = !!VARIANT[variant];
    const isValidSize = !!SIZE[size];

    useEffect(() => {
        variant && !VARIANT[variant] && console.error(`Invalid <Btn /> variant used! [variant='${variant}']`);
    }, [variant]);

    useEffect(() => { size && !SIZE[size] && console.error(`Invalid <Btn /> size used! [size='${size}']`); }, [size]);

    return (
        <button
            type={type} // eslint-disable-line react/button-has-type
            className={cn(
                CLASS,
                className,
                { 'has-icon': icon },
                isValidVariant && `${CLASS}-variant-${VARIANT[variant]}`,
                isValidSize && `${CLASS}-size-${SIZE[size]}`,
            )}
            {...rest}
        >
            {icon}
            {label}
            {children}
        </button>
    );
};

export default Btn;
